import { OptionType } from '../../../../../type/manage';

export const getCommunicationChannels = (t: (key: string) => string, isBetaAccount: boolean): OptionType[] => [
  { value: 'webhook', label: t('webhook') },
  { value: 'group', label: t('group'), hide: !isBetaAccount },
  { value: 'email', label: t('email') }
];
